<!-- selectGame with no layout free position with image background -->
<template>
  <div class="game-tr-select-game">
    <div class="overflow-wrappper">
      <div
        v-for="(image, index) in imageData"
        :key="'image_' + index"
        class="main-image-container"
        :style="getImageStyle(image)"
      ></div>
      <div
        class="text-element"
        v-for="(item, index) in textList"
        :key="'text_' + index"
        :style="getTextStyle(item)"
        v-html="item.text"
      ></div>
      <div
        class="select-container"
        :style="getElementStyle(item)"
        v-for="(item, index) in dataItems"
        :key="'item_' + index"
      >
        <tr-select
          :key="item.id"
          :config="selectConfig(item)"
          :options="item.answers"
          :input-width="inputWidth(item)"
          :input-height="inputHeight(item)"
          :tr-select-value="selected[index]"
          class="select-style"
          @change="setNewValue($event, index)"
        ></tr-select>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import * as utils from '../../Utils/inputUtils';
import TrSelect from '../TrSelect/TrSelect';
import defaultMixin from '../../mixins/defaultMixin';
import selectGameMixin from '../../mixins/selectGameMixin';
export default {
  name: 'tr-select-game',
  components: { TrSelect },
  mixins: [selectGameMixin, defaultMixin],
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      imageData: [],
      // inputWidth: this.startGameConfig.inputWidth,
      // inputHeight: this.startGameConfig.inputHeight,
      dataItems: {},
      textList: {},
      selected: [],
      zoomInnerModal: false,
    };
  },
  created() {},
  beforeMount() {
    this.init();
  },
  mounted() {},
  methods: {
    init() {
      this.selectGamePrepareData();
      this.selected = _.map(this.dataItems, (item) => {
        return {
          correct: item.correct,
          val: '',
          block: false,
          inputStatus: null,
        };
      });
    },
    /**
     * test if object objectExist
     * @method objectExist
     * @param  {*}    item testiing element
     * @return {Boolean}         true if is object
     */
    objectImageExist(item) {
      return _.isObject(item) && !_.isNil(item.imagePath);
    },
    getImageStyle(imageData) {
      if (_.isObject(imageData) && imageData.imagePath) {
        if (!imageData.pos) {
          imageData = Object.assign({}, imageData, {
            pos: {
              x: 0,
              y: 0,
            },
          });
        }
        if (!imageData.height) {
          imageData = Object.assign({}, imageData, {
            height: 358,
          });
        }
        if (!imageData.width) {
          imageData = Object.assign({}, imageData, {
            width: 1850,
          });
        }
      }
      return _.merge({ position: 'absolute' }, this.getCustomStyle(imageData), {
        'background-image': `url(${require(`__staticDir/${this.$store.getters.multibookType}/${imageData.imagePath}`)})`,
        top: utils.elementTopPosition(imageData.pos.y, imageData.offsetVertical),
        left: utils.elementLeftPosition(imageData.pos.x, imageData.offsetHorizontal),
        width: utils.elementWidth(imageData.width),
        height: utils.elementHeight(imageData.height),
      });
    },
    selectConfig(item) {
      return _.omit(item, ['pos', 'width', 'height']);
    },
    setNewValue(value, index) {
      let trValue = _.defaults({}, value, {
        correct: undefined,
        val: '',
        block: false,
        inputStatus: null,
      });
      trValue.val = value.text;
      _.assign(this.selected[index], trValue, { val: value });
    },
    getTextStyle(textElement) {
      textElement.offsetVertical = textElement.offsetVertical
        ? textElement.offsetVertical
        : this.startGameConfig.textElementOffsetVertical;
      textElement.offsetHorizontal = textElement.offsetHorizontal
        ? textElement.offsetHorizontal
        : this.startGameConfig.textElementOffsetHorizontal;
      textElement.width = textElement.width ? textElement.width : this.startGameConfig.textElementWidth;
      textElement.height = textElement.height ? textElement.height : this.startGameConfig.textElementHeight;
      return _.merge({ position: 'absolute' }, this.getCustomStyle(textElement), {
        top: utils.elementTopPosition(textElement.pos.y, textElement.offsetVertical),
        left: utils.elementLeftPosition(textElement.pos.x, textElement.offsetHorizontal),
        width: utils.elementWidth(textElement.width),
        height: utils.elementHeight(textElement.height),
        'background-color': textElement.backgroundColor || 'rgba(235, 210, 63,0.2)',
      });
    },
    getElementStyle(element) {
      element.offsetVertical = element.offsetVertical
        ? element.offsetVertical
        : this.startGameConfig.questionOffsetVertical;
      element.offsetHorizontal = element.offsetHorizontal
        ? element.offsetHorizontal
        : this.startGameConfig.questionOffsetHorizontal;
      element.width = element.width ? element.width : this.startGameConfig.questionWidth;
      element.height = element.height ? element.height : this.startGameConfig.questionHeight;
      return _.merge({ position: 'absolute' }, this.getCustomStyle(element), {
        top: utils.elementTopPosition(element.pos.y, element.offsetVertical),
        left: utils.elementLeftPosition(element.pos.x, element.offsetHorizontal),
        width: utils.elementWidth(element.width),
        height: utils.elementHeight(element.height),
      });
    },
    getCustomStyle(item) {
      let customStyle = {};
      if (item.cssStyle) {
        if (_.isObject(item.cssStyle)) {
          customStyle = _.mapKeys(item.cssStyle, function (value, key) {
            return _.toString(key);
          });
        }
      }
      return customStyle;
    },
    /**
     * reset all containerEnd without reset reactivity
     * @method resetGameAction
     */
    resetGameAction() {
      /** @type {Boolean} set gameCheckSwitch to false - remove statys icons */
      this.init();
      _.each(this.selected, (item, key, collection) => {
        item.val = '';
        item.text = '';
        item.block = false;
        item.inputStatus = null;
      });
    },
    checkGameAction() {
      let status = _.reduce(
        this.selected,
        (result, value, key) => {
          let temVal = null;
          if (value.correct) {
            temVal = result && true;
            value.block = true;
            value.inputStatus = 'correct';
          } else {
            temVal = false;
            value.block = true;
            value.inputStatus = 'incorrect';
            setTimeout(() => {
              value.val = '';
              value.block = false;
              value.inputStatus = null;
            }, 1000);
          }
          return temVal;
        },
        true
      );
      console.log('ANSWER: ', status);
      if (!status) {
        _.each(this.selected, (item, key) => {
          console.log('item', item);
        });
      }
      return status;
    },
    inputWidth(item) {
      if (item.inputWidth) {
        return item.inputWidth;
      } else if (this.startGameConfig.inputWidth) {
        return this.startGameConfig.inputWidth;
      } else {
        return false;
      }
    },
    inputHeight(item) {
      if (item.inputHeight) {
        return item.inputHeight;
      } else if (this.startGameConfig.inputHeight) {
        return this.startGameConfig.inputHeight;
      } else {
        return false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/sass/variable';
@import '~@/assets/sass/iconColor';
$elementWidth: 1478px;
$elementHeight: 153px;
// $textBackgroundColor: 'transparent';
// $textBackgroundColor: rgba($oddColor,0.2);
$fontSize: 35px;
%item {
  transition: all 0.5s;
  text-align: center;
  font-size: $fontSize;
  font-family: $gameFontFamily;
  font-style: normal;
  font-variant: normal;
  font-weight: 500;
}
.game-tr-select-game {
  width: 100%;
  height: 100%;
  padding-top: 140px;
  padding-bottom: 130px;
  overflow: hidden;
  .overflow-wrappper {
    width: 100%;
    // height: 100%;
    position: relative;
    // overflow: auto;
    .main-image-container {
      position: relative;
      display: block;
      width: $elementWidth;
      height: $elementHeight;
      margin-bottom: 10px;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center center;
    }
  }
}
.text-element {
  // background-color: $textBackgroundColor;
  font-size: $fontSize;
  text-align: left;
  padding: 10px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.question-wrapper {
  // position: relative;
  display: flex;
  // width: 1853px;
  // height: 153px;
  border-radius: 20px;
  border: 3px solid $backgroundControlPanelColor;
  margin-bottom: 20px;

  .question-container {
    width: 1478px;
    border-right: 3px solid $backgroundControlPanelColor;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .question-text {
      padding-left: 35px;
      text-align: left;
    }
  }
  .select-container {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 375px;
    .select-style {
      @extend %item;
      margin-left: 10px;
      width: 55%;
      height: 70px;
      option {
        @extend %item;
        font-size: 24px !important;
      }
    }
  }
}
</style>
